/**
 * ============================================================================
 * EverythingAnswered (MVC feature barrel)
 * ============================================================================
 * Purpose: Public entry for homepage "Everything Answered" FAQ section.
 * Wire: home-dynamic / LazyLoadSection → default export.
 * ============================================================================
 */

"use client";

import { useEverythingAnsweredController } from "./controller/useEverythingAnsweredController";
import EverythingAnsweredView from "./view/EverythingAnsweredView";
import type { EverythingAnsweredProps } from "./model/everything-answered.types";

export type {
  EverythingAnsweredProps,
  FaqPersona,
  FaqQuestion,
} from "./model/everything-answered.types";
export { mapQuestionsMapping } from "./mapper/everything-answered.mapper";

export default function EverythingAnswered(props: EverythingAnsweredProps) {
  const viewModel = useEverythingAnsweredController(props);
  return <EverythingAnsweredView {...viewModel} />;
}
